"use client";
import { createContext, useContext } from "react";
import { Zap } from "../structures/zap/useSearchZaps";

export const ZapContext = createContext<Zap | null>(null);

export const useCurrentZap = () => {
  const zap = useContext(ZapContext);
  if (!zap) {
    return null;
  }
  return zap;
};
